import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-786b4428"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row items-center justify-between w-full px-3 py-2 mb-2 text-center border-white custum-bg-opacity-40 border-b-1 rounded-xl" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sélection de siège", -1))
const _hoisted_3 = { class: "text-xs text-gray-400" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "ml-1 text-gray-500"
}
const _hoisted_6 = {
  key: 0,
  class: "flex flex-row items-center space-x-2 px-3 mb-2"
}
const _hoisted_7 = ["disabled", "title"]
const _hoisted_8 = { class: "flex flex-row items-center justify-between px-3 mb-2 text-xs" }
const _hoisted_9 = { class: "flex flex-row items-center space-x-3" }
const _hoisted_10 = { class: "legend-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legend-swatch seat-free" }, null, -1))
const _hoisted_12 = { class: "legend-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legend-swatch seat-occupied" }, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "legend-item"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legend-swatch seat-reserved" }, null, -1))
const _hoisted_16 = {
  key: 1,
  class: "legend-item"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legend-swatch seat-no-show" }, null, -1))
const _hoisted_18 = { class: "text-gray-400" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<span class=\"bus-wheel-well bus-wheel-well-top\" aria-hidden=\"true\" data-v-786b4428><svg viewBox=\"0 0 40 22\" preserveAspectRatio=\"none\" data-v-786b4428><path d=\"M 0 22 A 20 22 0 0 1 40 22 Z\" data-v-786b4428></path><line x1=\"20\" y1=\"22\" x2=\"20\" y2=\"2\" data-v-786b4428></line><line x1=\"20\" y1=\"22\" x2=\"6\" y2=\"6\" data-v-786b4428></line><line x1=\"20\" y1=\"22\" x2=\"34\" y2=\"6\" data-v-786b4428></line><line x1=\"20\" y1=\"22\" x2=\"2\" y2=\"14\" data-v-786b4428></line><line x1=\"20\" y1=\"22\" x2=\"38\" y2=\"14\" data-v-786b4428></line></svg></span><span class=\"bus-wheel-well bus-wheel-well-bottom\" aria-hidden=\"true\" data-v-786b4428><svg viewBox=\"0 0 40 22\" preserveAspectRatio=\"none\" data-v-786b4428><path d=\"M 0 0 A 20 22 0 0 0 40 0 Z\" data-v-786b4428></path><line x1=\"20\" y1=\"0\" x2=\"20\" y2=\"20\" data-v-786b4428></line><line x1=\"20\" y1=\"0\" x2=\"6\" y2=\"16\" data-v-786b4428></line><line x1=\"20\" y1=\"0\" x2=\"34\" y2=\"16\" data-v-786b4428></line><line x1=\"20\" y1=\"0\" x2=\"2\" y2=\"8\" data-v-786b4428></line><line x1=\"20\" y1=\"0\" x2=\"38\" y2=\"8\" data-v-786b4428></line></svg></span>", 2)
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 3v6M3 12h6M12 15v6M15 12h6" })
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["disabled", "draggable", "aria-label", "onClick", "onMouseenter", "onDragstart", "onDragover", "onDragleave", "onDrop"]
const _hoisted_24 = {
  key: 1,
  class: "text-[10px] text-gray-500 mt-2 px-3 text-center"
}
const _hoisted_25 = { class: "tooltip-row tooltip-seat" }
const _hoisted_26 = { class: "tooltip-row tooltip-name" }
const _hoisted_27 = {
  key: 0,
  class: "tooltip-row text-gray-300"
}
const _hoisted_28 = {
  key: 1,
  class: "tooltip-row text-gray-300"
}
const _hoisted_29 = { class: "tooltip-row text-gray-300" }
const _hoisted_30 = {
  key: 0,
  class: "tooltip-row text-gray-500"
}

import { computed, ref } from "vue";

	interface Passenger {
		uuid?: string;
		first_name?: string;
		last_name?: string;
		identity_no?: string;
		phone?: string;
		is_embarked?: boolean;
		tickets?: Array<{
			ticket_number?: string;
			chaise_number?: number | null;
			ticket_reserved?: boolean;
			created_at?: string;
		}>;
	}

	interface SeatInfo {
		number: number;
		passenger: Passenger | null;
		state: "free" | "occupied" | "reserved" | "selected" | "no-show";
		// Position dans la grille CSS (cf. JSDoc d'en-tête).
		// row = position intra-rangée (1..columns + 1 couloir)
		// col = colonne CSS effective (tient compte de la porte et du chauffeur)
		row: number;
		col: number;
	}

	
export default /*#__PURE__*/_defineComponent({
  __name: 'SeatLayoutPicker',
  props: {
    embarkation: {},
    passengers: {},
    selectedSeat: {},
    readonly: { type: Boolean, default: false },
    large: { type: Boolean, default: false }
  },
  emits: ["update:selectedSeat", "seat-click", "seat-swap-requested"],
  setup(__props: any, { emit: __emit }) {

	/**
	 * Visualisation du plan d'un véhicule + sélection d'un siège.
	 *
	 * REFONTE LAYOUT (PR-14 — illustration plate stock-photo v2)
	 * ─────────────────────────────────────────────────────────────────
	 * Le bus est représenté VU DE DESSUS, dans un seul corps oblong
	 * arrondi (style « pictogramme plat / illustration de stock ») :
	 *   - une SEULE forme continue (`.bus-body`) qui contient tout
	 *     (carrosserie, sièges, passages de roues, siège chauffeur, porte)
	 *   - extrémités très arrondies — l'avant (gauche) ET l'arrière
	 *     (droite) ont des `border-radius` ~50% de la hauteur pour donner
	 *     la silhouette « Tic-Tac » caractéristique du dessin de référence
	 *   - 2 passages de roues décoratifs en forme d'éventail (`fan`),
	 *     positionnés en absolu : haut-droite (≈ 3/4 depuis l'avant)
	 *     et bas-centre (juste après la porte vers la porte côté avant)
	 *   - une PORTE RECTANGULAIRE CENTRALE qui occupe TOUTE la hauteur
	 *     du bus, insérée dans la grille à la position ≈ 1/3 depuis
	 *     l'avant (cluster avant petit, cluster arrière plus grand).
	 *
	 * Architecture de grille (clé du design) :
	 *   - lignes CSS  = positions intra-rangée du bus (1..columns +1 couloir)
	 *   - colonnes CSS = colonne chauffeur (1) + N rangées du bus + 1 colonne
	 *                    porte insérée APRÈS la rangée `doorAt`.
	 *   - `doorAt` ≈ floor(busRowsCount / 3) (≥ 1) — pour Hiace 4 rangées
	 *     → 1, Coaster 8 rangées → 2, Marcopolo 12 rangées → 4.
	 *   - Les sièges des rangées 1..doorAt occupent les colonnes CSS
	 *     2..doorAt+1 (mêmes valeurs qu'avant). Les sièges des rangées
	 *     doorAt+1..busRowsCount sont décalés de +1 colonne CSS pour
	 *     passer la porte (qui occupe la colonne CSS `doorAt + 2`).
	 *   - La porte est rendue via `grid-column: doorAt + 2;
	 *     grid-row: 1 / -1` → traverse toute la hauteur du bus.
	 *
	 * Numérotation conservée à 100% (siège 1 = première fenêtre côté
	 * chauffeur, soit haut-gauche du rendu horizontal ; siège suivant =
	 * ligne d'en dessous dans la même rangée du bus ; on remplit rangée
	 * par rangée de l'avant vers l'arrière). Cf. seatCellRow / seatCellCol.
	 *
	 * Source de vérité = `embarkation.vehicle.place_number` (capacité) et
	 * la liste `passengers` (chaque entrée contient `tickets[0].chaise_number`).
	 * Le composant est purement présentationnel : il N'APPELLE PAS l'API.
	 * Il émet `update:selectedSeat` quand l'utilisateur clique un siège
	 * libre, et `seat-click` quand il clique un siège déjà occupé.
	 */
	const props = __props;

	const emit = __emit;

	// ────────────────────────────────────────────────────────────────
	// Capacité — fallback 20 places si le véhicule n'expose pas place_number.
	// ────────────────────────────────────────────────────────────────
	const capacity = computed<number>(() => {
		const n = Number(props.embarkation?.vehicle?.place_number);
		return Number.isFinite(n) && n > 0 ? n : 20;
	});

	// ────────────────────────────────────────────────────────────────
	// Layout — vehicle.vehicle_type.seat_layout = { columns, aisle_after, label }.
	// `columns` = nombre de sièges côte à côte dans une rangée du bus
	// (3 pour minivan, 4 pour Hiace/Coaster, 5 pour Marcopolo grand format).
	// `aisle_after` = nombre de sièges du côté chauffeur avant le couloir
	// (1 pour Hiace 1+couloir+3, 2 pour Coaster 2+couloir+2, etc.).
	// ────────────────────────────────────────────────────────────────
	const layoutColumns = computed<number>(() => {
		const c = Number(props.embarkation?.vehicle?.vehicle_type?.seat_layout?.columns);
		return Number.isFinite(c) && c >= 1 && c <= 8 ? c : 4;
	});
	const aisleAfter = computed<number>(() => {
		const a = props.embarkation?.vehicle?.vehicle_type?.seat_layout?.aisle_after;
		if (a == null) return 2;
		const n = Number(a);
		return Number.isFinite(n) && n >= 0 && n <= layoutColumns.value ? n : 2;
	});
	const layoutLabel = computed<string | null>(() => {
		return props.embarkation?.vehicle?.vehicle_type?.seat_layout?.label ?? null;
	});

	// Nombre de rangées de sièges du bus (= colonnes principales dans le DOM).
	// Une rangée incomplète (dernière) est tout de même rendue : on laisse
	// les cellules vides plutôt que de faire « monter » le siège manquant.
	const busRowsCount = computed<number>(() =>
		Math.ceil(capacity.value / layoutColumns.value)
	);

	// Le couloir CSS est-il rendu ? On l'omet quand aisle_after vaut 0
	// ou égale layoutColumns (i.e. siège tout au bord — pas un vrai couloir).
	const hasAisle = computed<boolean>(
		() => aisleAfter.value > 0 && aisleAfter.value < layoutColumns.value
	);

	// PR-14bis — Porte verticale RETIRÉE.
	// La référence visuelle ne montre pas de bar vertical qui traverse
	// le bus de haut en bas. On garde les variables pour neutraliser le
	// mapping seatCellCol (doorOffset toujours 0) — comportement
	// équivalent à `hasDoor = false` partout.
	const doorAt = computed<number>(() => 0);
	const hasDoor = computed<boolean>(() => false);

	// Index des passagers par numéro de siège.
	const seatToPassenger = computed<Record<number, Passenger>>(() => {
		const map: Record<number, Passenger> = {};
		for (const p of props.passengers ?? []) {
			const seat = p.tickets?.[0]?.chaise_number;
			if (seat != null) map[Number(seat)] = p;
		}
		return map;
	});

	const reservationCount = computed(
		() =>
			(props.passengers ?? []).filter(
				(p) => p.tickets?.length && p.tickets[0]?.chaise_number == null
			).length
	);

	// No-show detection : embarquement en cours (status >= 3) et passager
	// pas embarqué → siège affiché en rouge (les réservations restent jaunes).
	const isEmbarkationInProgress = computed<boolean>(() => {
		const statusId = Number(props.embarkation?.embarkation_status_id);
		return Number.isFinite(statusId) && statusId >= 3;
	});

	// ────────────────────────────────────────────────────────────────
	// Mapping seat number → cell row/col (cœur de la transposition)
	// ────────────────────────────────────────────────────────────────
	// Le siège N (1-indexé) appartient à la rangée du bus
	//     busRow = ceil(N / columns)            ∈ [1..busRowsCount]
	// et occupe à l'intérieur de cette rangée la position
	//     inRow  = ((N - 1) mod columns) + 1    ∈ [1..columns]
	//
	// Comme on PIVOTE de 90°, busRow devient la colonne CSS, et inRow la
	// ligne CSS. La ligne CSS est en plus décalée de +1 quand on passe le
	// couloir (qui occupe une ligne CSS supplémentaire positionnée juste
	// après aisle_after — donc inRow > aisleAfter doit prendre +1).
	//
	// IMPORTANT v2 — DOUBLE DÉCALAGE de colonne CSS :
	//   1) +1 pour laisser la colonne 1 au siège chauffeur (cabine
	//      intégrée à la grille → un seul corps oblong continu).
	//   2) +1 supplémentaire pour les rangées APRÈS la porte (busRow >
	//      doorAt), qui doivent sauter la colonne CSS occupée par la
	//      porte. Du coup la colonne CSS finale est :
	//         busRow + 1                  si busRow ≤ doorAt
	//         busRow + 2                  si busRow >  doorAt et hasDoor
	//   La numérotation côté API reste identique (seatToPassenger).
	function seatCellCol(seatNumber: number): number {
		const busRow = Math.ceil(seatNumber / layoutColumns.value);
		const doorOffset = hasDoor.value && busRow > doorAt.value ? 1 : 0;
		// +1 pour la colonne chauffeur, +doorOffset pour passer la porte.
		return busRow + 1 + doorOffset;
	}
	function seatCellRow(seatNumber: number): number {
		const inRow = ((seatNumber - 1) % layoutColumns.value) + 1;
		// +1 pour passer la ligne CSS du couloir (présent uniquement si hasAisle).
		const aisleOffset = hasAisle.value && inRow > aisleAfter.value ? 1 : 0;
		return inRow + aisleOffset;
	}

	const seats = computed<SeatInfo[]>(() => {
		const out: SeatInfo[] = [];
		for (let n = 1; n <= capacity.value; n++) {
			const passenger = seatToPassenger.value[n] ?? null;
			let state: SeatInfo["state"] = "free";
			if (props.selectedSeat === n) {
				state = "selected";
			} else if (passenger) {
				const reserved = !!passenger.tickets?.[0]?.ticket_reserved;
				const embarked = !!passenger.is_embarked;
				if (isEmbarkationInProgress.value && !embarked && !reserved) {
					state = "no-show";
				} else {
					state = reserved ? "reserved" : "occupied";
				}
			}
			out.push({
				number: n,
				passenger,
				state,
				row: seatCellRow(n),
				col: seatCellCol(n),
			});
		}
		return out;
	});

	// Nombre total de lignes CSS de la grille (sièges + couloir éventuel).
	const totalGridRows = computed<number>(
		() => layoutColumns.value + (hasAisle.value ? 1 : 0)
	);
	// Index 1-based de la ligne CSS du couloir (inséré après aisle_after).
	const aisleCssRow = computed<number>(() => aisleAfter.value + 1);

	// Nombre total de colonnes CSS : 1 (chauffeur) + busRowsCount + 1 (porte si présente).
	const totalGridCols = computed<number>(
		() => 1 + busRowsCount.value + (hasDoor.value ? 1 : 0)
	);
	// Colonne CSS de la porte = chauffeur (1) + doorAt rangées avant + 1.
	const doorGridCol = computed<number>(() => doorAt.value + 2);

	// Ligne CSS du siège chauffeur : on le place sur la 1ʳᵉ position
	// (côté fenêtre) — il s'aligne avec la première paire de sièges du haut.
	const driverGridRow = computed<number>(() => 1);

	// ────────────────────────────────────────────────────────────────
	// Auto-attribution — bouton "Auto" : sélectionne le premier siège libre.
	// ────────────────────────────────────────────────────────────────
	function autoAssignFirstFree() {
		if (props.readonly) return;
		const free = seats.value.find((s) => s.state === "free");
		if (!free) return;
		emit("update:selectedSeat", free.number);
	}

	// ────────────────────────────────────────────────────────────────
	// Recherche — flash le siège correspondant au nom / pièce / ticket.
	// ────────────────────────────────────────────────────────────────
	const searchQuery = ref("");
	const flashSeat = computed<number | null>(() => {
		const q = searchQuery.value.trim().toLowerCase();
		if (q.length < 2) return null;
		for (const p of props.passengers ?? []) {
			const seat = p.tickets?.[0]?.chaise_number;
			if (seat == null) continue;
			const haystack = [
				p.first_name,
				p.last_name,
				p.identity_no,
				p.phone,
				p.tickets?.[0]?.ticket_number,
			]
				.filter(Boolean)
				.join(" ")
				.toLowerCase();
			if (haystack.includes(q)) return Number(seat);
		}
		return null;
	});

	const occupiedCount = computed(
		() => Object.keys(seatToPassenger.value).length
	);
	const freeCount = computed(() => capacity.value - occupiedCount.value);
	const noShowCount = computed(
		() => seats.value.filter((s) => s.state === "no-show").length
	);

	// ────────────────────────────────────────────────────────────────
	// Interactions
	// ────────────────────────────────────────────────────────────────
	function handleClick(seat: SeatInfo) {
		if (props.readonly) return;
		if (seat.state === "free") {
			const next = props.selectedSeat === seat.number ? null : seat.number;
			emit("update:selectedSeat", next);
		} else if (seat.state === "selected") {
			emit("update:selectedSeat", null);
		} else if (seat.passenger) {
			emit("seat-click", { seat: seat.number, passenger: seat.passenger });
		}
	}

	// ────────────────────────────────────────────────────────────────
	// Tooltip flottant (Teleport to body pour échapper aux overflow:hidden).
	// ────────────────────────────────────────────────────────────────
	const tooltipVisible = ref(false);
	const tooltipX = ref(0);
	const tooltipY = ref(0);
	const tooltipSeat = ref<SeatInfo | null>(null);

	function showTooltip(seat: SeatInfo, ev: MouseEvent) {
		tooltipSeat.value = seat;
		tooltipX.value = ev.clientX + 14;
		tooltipY.value = ev.clientY + 14;
		tooltipVisible.value = true;
	}

	function moveTooltip(ev: MouseEvent) {
		if (!tooltipVisible.value) return;
		tooltipX.value = ev.clientX + 14;
		tooltipY.value = ev.clientY + 14;
	}

	function hideTooltip() {
		tooltipVisible.value = false;
		tooltipSeat.value = null;
	}

	function fullName(p?: Passenger | null): string {
		if (!p) return "";
		return [p.first_name, p.last_name].filter(Boolean).join(" ").trim();
	}

	// ────────────────────────────────────────────────────────────────
	// Drag & drop (PR-3) — swap/move de siège, le parent confirme + appelle l'API.
	// ────────────────────────────────────────────────────────────────
	const draggingSeat = ref<number | null>(null);
	const hoverTargetSeat = ref<number | null>(null);

	function onDragStart(seat: SeatInfo, ev: DragEvent) {
		if (props.readonly || !seat.passenger) {
			ev.preventDefault();
			return;
		}
		draggingSeat.value = seat.number;
		hideTooltip();
		ev.dataTransfer?.setData("text/plain", String(seat.number));
		ev.dataTransfer!.effectAllowed = "move";
	}

	function onDragEnd() {
		draggingSeat.value = null;
		hoverTargetSeat.value = null;
	}

	function onDragOver(seat: SeatInfo, ev: DragEvent) {
		if (props.readonly) return;
		if (draggingSeat.value == null || draggingSeat.value === seat.number) return;
		ev.preventDefault();
		hoverTargetSeat.value = seat.number;
	}

	function onDragLeave(seat: SeatInfo) {
		if (hoverTargetSeat.value === seat.number) {
			hoverTargetSeat.value = null;
		}
	}

	function onDrop(target: SeatInfo, ev: DragEvent) {
		ev.preventDefault();
		const source = draggingSeat.value;
		draggingSeat.value = null;
		hoverTargetSeat.value = null;
		if (source == null || source === target.number) return;

		const sourcePassenger = seatToPassenger.value[source];
		if (!sourcePassenger) return;

		emit("seat-swap-requested", {
			sourceSeat: source,
			sourcePassenger,
			targetSeat: target.number,
			targetPassenger: target.passenger,
		});
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["seat-picker flex flex-col w-full", {
			'seat-picker-large': _ctx.large,
			// Active la palette compacte pour les bus à grande capacité
			// (Marcopolo 60p, autocars 70-75p) — sièges plus petits et
			// gaps resserrés pour que tout tienne dans la modale sans
			// scroll horizontal excessif (PR-14quater).
			'seat-picker--long-bus': busRowsCount.value > 12,
		}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.embarkation?.vehicle?.mark_name ?? "—") + " ", 1),
        (_ctx.embarkation?.vehicle?.registration_no)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " · " + _toDisplayString(_ctx.embarkation.vehicle.registration_no), 1))
          : _createCommentVNode("", true),
        (layoutLabel.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "· " + _toDisplayString(layoutLabel.value), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (!_ctx.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
            placeholder: "Rechercher (nom, pièce, n° ticket)",
            class: "flex-1 text-xs px-2 py-1 rounded bg-[#1f2937] border border-[#374151] text-gray-200 focus:outline-none focus:border-blue-500"
          }, null, 512), [
            [_vModelText, searchQuery.value]
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "text-xs px-2 py-1 rounded bg-[#219152] hover:bg-[#167841] text-white disabled:opacity-40 disabled:cursor-not-allowed",
            disabled: freeCount.value === 0,
            title: freeCount.value === 0 ? 'Aucun siège libre' : 'Attribuer le premier siège libre',
            onClick: autoAssignFirstFree
          }, " Auto ", 8, _hoisted_7)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, [
          _hoisted_11,
          _createTextVNode(" Libre (" + _toDisplayString(freeCount.value) + ") ", 1)
        ]),
        _createElementVNode("span", _hoisted_12, [
          _hoisted_13,
          _createTextVNode(" Occupé (" + _toDisplayString(occupiedCount.value) + ") ", 1)
        ]),
        (reservationCount.value > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
              _hoisted_15,
              _createTextVNode(" Réservation (" + _toDisplayString(reservationCount.value) + ") ", 1)
            ]))
          : _createCommentVNode("", true),
        (noShowCount.value > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
              _hoisted_17,
              _createTextVNode(" No-show (" + _toDisplayString(noShowCount.value) + ") ", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_18, _toDisplayString(occupiedCount.value) + "/" + _toDisplayString(capacity.value), 1)
    ]),
    _createElementVNode("div", {
      class: "bus-scroll mx-3",
      onMouseleave: hideTooltip
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["bus-body", { 'bus-body-large': _ctx.large }])
      }, [
        _hoisted_19,
        _createElementVNode("div", {
          class: "seat-grid",
          style: _normalizeStyle({
						gridTemplateColumns: hasDoor.value
							? `var(--driver-col-width) repeat(${doorAt.value}, var(--seat-size)) var(--door-width) repeat(${busRowsCount.value - doorAt.value}, var(--seat-size))`
							: `var(--driver-col-width) repeat(${busRowsCount.value}, var(--seat-size))`,
						gridTemplateRows: hasAisle.value
							? `repeat(${aisleAfter.value}, var(--seat-size)) var(--aisle-size) repeat(${layoutColumns.value - aisleAfter.value}, var(--seat-size))`
							: `repeat(${layoutColumns.value}, var(--seat-size))`,
					})
        }, [
          (hasAisle.value)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "seat-aisle",
                style: _normalizeStyle({
							gridRow: aisleCssRow.value,
							gridColumn: `1 / span ${totalGridCols.value}`,
						}),
                "aria-hidden": "true"
              }, null, 4))
            : _createCommentVNode("", true),
          (hasDoor.value)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "bus-door",
                style: _normalizeStyle({
							gridColumn: doorGridCol.value,
							gridRow: `1 / span ${totalGridRows.value}`,
						}),
                "aria-hidden": "true"
              }, null, 4))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "driver-seat",
            style: _normalizeStyle({ gridColumn: 1, gridRow: driverGridRow.value }),
            title: "Siège chauffeur",
            "aria-label": "Siège chauffeur"
          }, _hoisted_22, 4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seats.value, (seat) => {
            return (_openBlock(), _createElementBlock("button", {
              key: seat.number,
              type: "button",
              class: _normalizeClass(["seat seat-passenger", [
							`seat-${seat.state}`,
							{
								'cursor-not-allowed': _ctx.readonly && seat.state === 'free',
								'seat-dragging': draggingSeat.value === seat.number,
								'seat-drop-target': hoverTargetSeat.value === seat.number,
								'seat-flash': flashSeat.value === seat.number,
							},
						]]),
              style: _normalizeStyle({ gridRow: seat.row, gridColumn: seat.col }),
              disabled: _ctx.readonly && seat.state === 'free',
              draggable: !_ctx.readonly && !!seat.passenger,
              "aria-label": seat.passenger
							? `Siège ${seat.number} — ${fullName(seat.passenger)}`
							: `Siège ${seat.number} libre`,
              onClick: ($event: any) => (handleClick(seat)),
              onMouseenter: (ev) => showTooltip(seat, ev),
              onMousemove: moveTooltip,
              onMouseleave: hideTooltip,
              onDragstart: (ev) => onDragStart(seat, ev),
              onDragend: onDragEnd,
              onDragover: (ev) => onDragOver(seat, ev),
              onDragleave: ($event: any) => (onDragLeave(seat)),
              onDrop: (ev) => onDrop(seat, ev)
            }, _toDisplayString(seat.number), 47, _hoisted_23))
          }), 128))
        ], 4)
      ], 2)
    ], 32),
    (!_ctx.readonly && occupiedCount.value > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Astuce : glisser un siège occupé sur un autre pour déplacer / échanger "))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (tooltipVisible.value && tooltipSeat.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "seat-tooltip",
            style: _normalizeStyle({ left: tooltipX.value + 'px', top: tooltipY.value + 'px' }),
            role: "tooltip"
          }, [
            _createElementVNode("div", _hoisted_25, [
              _createTextVNode(" Siège "),
              _createElementVNode("strong", null, _toDisplayString(tooltipSeat.value.number), 1)
            ]),
            (tooltipSeat.value.passenger)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(fullName(tooltipSeat.value.passenger) || "Passager sans nom"), 1),
                  (tooltipSeat.value.passenger.identity_no)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, " Pièce : " + _toDisplayString(tooltipSeat.value.passenger.identity_no), 1))
                    : _createCommentVNode("", true),
                  (tooltipSeat.value.passenger.tickets?.[0]?.ticket_number)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, " Ticket : " + _toDisplayString(tooltipSeat.value.passenger.tickets[0].ticket_number), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["tooltip-row mt-1", tooltipSeat.value.state === 'reserved' ? 'text-yellow-300' : 'text-green-300'])
                  }, _toDisplayString(tooltipSeat.value.state === 'reserved' ? 'Réservation payée' : 'Embarquement confirmé'), 3)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_29, _toDisplayString(tooltipSeat.value.state === 'selected' ? 'Siège sélectionné' : 'Siège libre'), 1),
                  (!_ctx.readonly && tooltipSeat.value.state !== 'selected')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, " Cliquer pour sélectionner "))
                    : _createCommentVNode("", true)
                ], 64))
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ], 2))
}
}

})